import { inject, Injectable } from "@angular/core";
import { WebsocketClientWrapper } from "../../market/websocket-client-factory";
import { BybitDealHandler } from "./exchange/bybit-deal.handler";
import { BinanceDealHandler } from "./exchange/binance-deal.handler";
import { OkxDealHandler } from "./exchange/okx-deal.handler";

@Injectable({
  providedIn: 'root'
})
export class DealHandler {

  private bybitHandler = inject(BybitDealHandler)
  private binanceHandler = inject(BinanceDealHandler)
  private okxHandler = inject(OkxDealHandler)

  listen(ws: WebsocketClientWrapper) {
    if (ws.isBybit) {
      return this.bybitHandler.listen(ws.bybit)
    }
    if (ws.isBinance) {
      return this.binanceHandler.listen(ws.binance)
    }
    if (ws.isOkx) {
      return this.okxHandler.listen(ws.okx)
    }
    throw new Error(`Unknown WebsocketClientWrapper`)
  }

}
